import React, { useCallback, useState, useEffect } from 'react'
import styles from './styles.module.less'
import cn from 'classnames';
import { Button, message, Input, Menu, Avatar, Icon, Modal, Form, Tooltip, Divider, Timeline } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { orderStatus } from '@/models/orders/defines/constants'
import { showAccessoryDetailDialog } from '@/models/orders/actions'
import { getCurrentUser } from '@/models/user/selectors';
import * as services from '@/models/orders/services';
import dayjs from 'dayjs';
import PhotoSwipe from 'photoswipe/dist/photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

const isManagerMode = process.env.APP_MODE === 'manager';

function OrderRow(props) {
  return (
    <div className={cn(styles.row, props.block && styles.block)}>
      <div className={styles.rowTit}>{props.title}</div>
      <div className={styles.rowBody}>{props.children}</div>
    </div>
  );
}
const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },

};
function OrderNotice(props) {
  const { orderId, order, form } = props
  const { getFieldDecorator, validateFields, getFieldValue, setFieldsValue, resetFields } = form;

  const dispatch = useDispatch()
  const user = useSelector(getCurrentUser);
  const [isOpen, setIsOpen] = useState(false)
  const [modalTitle, setModalTitle] = useState('')
  const [modalType, setModalType] = useState(1)
  const [basicInfo, setBasicInfo] = useState({})

  const handleAddAccessory = useCallback((accessory, order) => {
    dispatch(
      showAccessoryDetailDialog({
        title: `配件管理`,
        accessory: accessory,
        order: order.toJS(),
        user: user.toJS(),
        // onSuccess: onSuccess
      })
    );
  }, [order]);

  const initData = () => {
    services.orderWaitOp({ orderId })
      .then((result) => {
        setBasicInfo(result || {})
      })
      .catch((err) => {
        message.error(err.message || '获取数据失败，请刷新重试');
      })
      .finally(() => {
      });
  }
  const openModal = (title = '', type = 1) => {
    setModalTitle(title)
    setModalType(type)
    setIsOpen(true)
  }
  const closeModal = () => {
    setModalTitle('')
    setModalType(1)
    setIsOpen(false)
  }
  const handleSubmit = () => {
    validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }
      if (modalType == 1) {
        const params = {
          applyFeeId: basicInfo.applyFee._id,
          status_flag: 1,
          reason: ''
        }
        services.saveApplyFeeCheck(params).then(res => {
          initData()
          closeModal()
          message.success('操作成功');
        }).catch((err) => {
          message.error(err?.message || '提交失败');
        })
      } else if (modalType == 2) {
        const params = {
          applyFeeId: basicInfo.applyFee._id,
          status_flag: 2,
          reason: values.reason
        }
        services.saveApplyFeeCheck(params).then(res => {
          initData()
          closeModal()
          message.success('操作成功');
        }).catch((err) => {
          message.error(err?.message || '提交失败');
        })
      } else if (modalType == 3) {
        const params = {
          id: basicInfo.evaluate._id,
          appeal_flag: 1,
          refuse_reason: ''
        }
        services.saveEvaluateCheck(params).then(res => {
          initData()
          closeModal()
          message.success('操作成功');
        }).catch((err) => {
          message.error(err?.message || '提交失败');
        })
      } else if (modalType == 4) {
        const params = {
          id: basicInfo.evaluate._id,
          appeal_flag: 2,
          refuse_reason: values.reason
        }
        services.saveEvaluateCheck(params).then(res => {
          initData()
          closeModal()
          message.success('操作成功');
        }).catch((err) => {
          message.error(err?.message || '提交失败');
        })
      } else if (modalType == 5) {
        const params = {
          spId: basicInfo.claimList._id,
          state: 1,
          refuse_reason: ''
        }
        services.saveClaimCheck(params).then(res => {
          initData()
          closeModal()
          message.success('操作成功');
        }).catch((err) => {
          message.error(err?.message || '提交失败');
        })
      } else if (modalType == 6) {
        const params = {
          spId: basicInfo.claimList._id,
          state: 2,
          refuse_reason: values.reason
        }
        services.saveClaimCheck(params).then(res => {
          initData()
          closeModal()
          message.success('操作成功');
        }).catch((err) => {
          message.error(err?.message || '提交失败');
        })
      } else if (modalType == 7 || modalType == 8) {
        let appealState = 1;
        if (modalType == 7) {
          appealState = 2;
        } else if (modalType == 8) {
          appealState = 3;
        }
        const params = {
          ...basicInfo.appealList,
          appeal_state: appealState,
          description: values.reason
        }
        services.appealOrder(orderId, params).then(res => {
          initData()
          closeModal()
          message.success('操作成功');
        }).catch((err) => {
          message.error(err?.message || '提交失败');
        })
      } else if (modalType == 10) {
        const params = {
          arbId: basicInfo.arbitration?._id,
          reason: values.reason,
          status: 2
        }
        managerArbitrationCheck(params)
      }

    });
  }
  const managerArbitrationCheck = async (params = {}) => {
    services.managerArbitrationCheck(params).then(res => {
      initData()
      closeModal()
      message.success('操作成功');
    }).catch((err) => {
      message.error(err?.message || '提交失败');
    })
  }

  const previewImage = useCallback(async (images = [], idx) => {
    const pswpElement = document.querySelectorAll('.pswp')[0];

    const items = []
    for (let i = 0; i < images.length; i++) {
      const item = images[i]
      let w
      let h
      if (item.dimensions) {
        w = item.dimensions.width
        h = item.dimensions.height
      } else {
        const { width, height } = await getImageWidth(item.url)
        w = width
        h = height
      }
      items.push({ src: item.url, w, h })
    }
    const options = {
      index: idx,
      history: false,
      tapToClose: false,
    };
    // Initializes and opens PhotoSwipe
    const gallery = new PhotoSwipe(
      pswpElement,
      PhotoSwipeUI_Default,
      items,
      options
    );
    gallery.init();
  });

  function getImageWidth(url) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.src = url;
      let obj = {}
      // 如果图片被缓存，则直接返回缓存数据
      if (img.complete) {
        obj.width = img.width;
        obj.height = img.height;
        resolve(obj)
      } else {
        img.onload = function () {
          obj.width = img.width;
          obj.height = img.height;
          resolve(obj)
        }
      }
    });

  }
  useEffect(() => {
    if (orderId) {
      initData()
    }
  }, [order, orderId]);
  useEffect(() => {
    initData()

    return () => { }
  }, []);

  return (
    <div className={styles.orderNotice}>
      {basicInfo.accessory && basicInfo.accessory?.length > 0 && <div className={styles.block}>
        <div className={styles.blocktitle}>
          <div className={styles.titletext}>师傅申请配件</div>
          <div className={styles.titletime}>申请时间：{dayjs(basicInfo.accessory.createdAt).format("YYYY-MM-DD HH:mm:ss")}</div>
        </div>
        {basicInfo.accessory?.map((item, index) => <div className={styles.blockbody} key={index}>
          {index > 0 && <Divider style={{
            margin: '0 0 20px',
            background: '#cdcdcd'
          }} />}
          <OrderRow title="配件名称">{item?.name}（数量：{item?.num || 0}）</OrderRow>
          <OrderRow title="申请原因">{item?.reason}</OrderRow>
          <OrderRow title="申请时间">{dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss")}</OrderRow>
          <OrderRow title="现场照片">
            {item?.accessory_images?.map((val, indx) => {
              return (
                <Tooltip title={val.desc} key={indx}>
                  <Avatar shape="square" size={60} key={indx} src={val.url}
                    style={{ margin: '0 10px 10px 0' }}
                    onClick={() => previewImage(item?.accessory_images, indx)}
                  />
                </Tooltip>
              )
            })}
          </OrderRow>
          <OrderRow>
            <Button type="primary" size="small" style={{ marginLeft: '10px' }}
              onClick={handleAddAccessory.bind(this, item, order)}
            >发货</Button>
          </OrderRow>
        </div>)}
      </div>}
      {isManagerMode && <>

        {basicInfo.evaluate && <div className={styles.block}>
          <div className={styles.blocktitle}>
            <div className={styles.titletext}>师傅评论申诉</div>
            <div className={styles.titletime}>申诉时间：{dayjs(basicInfo.evaluate.appeal_time).format("YYYY-MM-DD HH:mm:ss")}</div>
          </div>
          <div className={styles.blockbody}>
            <OrderRow title="申诉说明">{basicInfo.evaluate.appeal_reason}</OrderRow>
            <OrderRow title="现场照片">
              {basicInfo.evaluate.appeal_images?.map((val, indx) => {
                return (
                  <Avatar shape="square" size={94} key={indx} src={val}
                    style={{ margin: '0 10px 10px 0' }}
                    onClick={() => previewImage(basicInfo.evaluate.appeal_images, indx)}
                  />
                )
              })}
            </OrderRow>
          </div>
          <div className={styles.blockfoot}>
            <Button type="primary" size="small" style={{ marginLeft: '10px' }}
              onClick={() => { openModal('同意师傅评论申诉', 3) }}
            >同意</Button>
            <Button type="primary" size="small" style={{ marginLeft: '10px' }}
              onClick={() => { openModal('拒绝师傅评论申诉', 4) }}
            >拒绝</Button>
          </div>
        </div>}

        {basicInfo.claimList && <div className={styles.block}>
          <div className={styles.blocktitle}>
            <div className={styles.titletext}>{order?.get('is_retail') ? '散户' : '商家'}索赔</div>
            <div className={styles.titletime}>索赔时间：{dayjs(basicInfo.claimList.sp_time).format("YYYY-MM-DD HH:mm:ss")}</div>
          </div>
          <div className={styles.blockbody}>
            <OrderRow title="索赔金额">
              <span className={styles.textcolor1} >
                {basicInfo.claimList.sp_amount}元
              </span>
            </OrderRow>
            <OrderRow title="申请原因">{basicInfo.claimList.sp_reason}</OrderRow>
            <OrderRow title="现场照片">
              {basicInfo.claimList.images?.map((val, indx) => {
                return (
                  <Avatar shape="square" size={94} key={indx} src={val}
                    style={{ margin: '0 10px 10px 0' }}
                    onClick={() => previewImage(basicInfo.claimList?.images?.map(v => ({ url: v })), indx)}
                  />
                )
              })}
            </OrderRow>
          </div>
          <div className={styles.blockfoot}>
            <Button type="primary" size="small" style={{ marginLeft: '10px' }}
              onClick={() => { openModal(`同意${order?.get('is_retail') ? '散户' : '商家'}索赔`, 5) }}
            >同意</Button>
            <Button type="primary" size="small" style={{ marginLeft: '10px' }}
              onClick={() => { openModal(`拒绝${order?.get('is_retail') ? '散户' : '商家'}索赔`, 6) }}
            >拒绝</Button>
          </div>
        </div>}

        {(Array.isArray(basicInfo.claimOkList) && basicInfo.claimOkList.length > 0) && basicInfo.claimOkList.map((item, index) => (
          <div className={styles.block} key={index}>
            <div className={styles.blocktitle}>
              <div className={styles.titletext}>{order?.get('is_retail') ? '散户' : '商家'}索赔</div>
              <div className={styles.titletime}>索赔时间：{dayjs(item.sp_time).format("YYYY-MM-DD HH:mm:ss")}</div>
            </div>
            <div className={styles.blockbody}>
              <OrderRow title="索赔金额">
                <span className={styles.textcolor1} >
                  {item.sp_amount}元
                </span>
              </OrderRow>
              <OrderRow title="申请原因">{item.sp_reason}</OrderRow>
              <OrderRow title="现场照片">
                {item.images?.map((val, indx) => {
                  return (
                    <Avatar shape="square" size={94} key={indx} src={val}
                      style={{ margin: '0 10px 10px 0' }}
                      onClick={() => previewImage(item?.images?.map(v => ({ url: v })), indx)}
                    />
                  )
                })}
              </OrderRow>
            </div>
          </div>
        ))}

        {/* 仲裁 */}
        {basicInfo.arbitration && <div className={styles.block}>
          <div className={styles.blockbody}>
            <div>
              <Timeline>
                <Timeline.Item>
                {basicInfo.arbitration.arbTypeNum == 1 &&<p>
                  <span style={{ color: '#333' }}>散户 {basicInfo?.arbitration?.user?.name} 申请下调工单费用</span>
                    <span style={{ paddingLeft: '20px' }}>申请时间：{dayjs(basicInfo.arbitration?.arbitrationRelation?.createdAt).format("YYYY-MM-DD HH:mm:ss")}</span>
                  </p>
                  }
                  {basicInfo.arbitration.arbTypeNum == 1 &&<div style={{ padding: '10px', background: '#fbcecb' }}>
                    <OrderRow title="申请费用">
                      {basicInfo.arbitration?.arbitrationRelation?.detail?.map((item, index) => `${item.name}${(item.price*1)?.toFixed(2)}元 ${index < basicInfo.arbitration?.arbitrationRelation?.detail.length - 1 ? "/" : ""}`).join(' ') || ''}
                    </OrderRow>
                    <OrderRow title="申请原因">
                      {basicInfo.arbitration?.arbitrationRelation?.remark || ''}
                    </OrderRow>
                    <OrderRow title="图片">
                      {basicInfo.arbitration?.arbitrationRelation?.resource_file?.map((item, index) => {
                        return (
                          <img src={item} key={index} style={{ width: 48, height: 48 }}
                            onClick={() => previewImage(basicInfo.arbitration?.arbitrationRelation?.resource_file?.map(v => ({ url: v })), index)}
                          />
                        )
                      })}
                    </OrderRow>
                  </div>
                  }

                  {basicInfo.arbitration.arbTypeNum == 2 &&<p>
                  <span style={{ color: '#333' }}>散户 {basicInfo?.arbitration?.user?.name} 申请退款</span>
                    <span style={{ paddingLeft: '20px' }}>申请时间：{dayjs(basicInfo.arbitration?.arbitrationRelation?.createdAt).format("YYYY-MM-DD HH:mm:ss")}</span>
                  </p>
                  }

                  {basicInfo.arbitration.arbTypeNum == 2 &&<div style={{ padding: '10px', background: '#fbcecb' }}>
                    <OrderRow title="申请原因">
                      {basicInfo.arbitration?.arbitrationRelation?.back_reason || ''}
                    </OrderRow>
                    <OrderRow title="图片">
                      {basicInfo.arbitration?.arbitrationRelation?.resource_file?.map((item, index) => {
                        return (
                          <img src={item} key={index} style={{ width: 48, height: 48 }}
                            onClick={() => previewImage(basicInfo.arbitration?.arbitrationRelation?.resource_file?.map(v => ({ url: v })), index)}
                          />
                        )
                      })}
                    </OrderRow>
                  </div>
                  }

                  {basicInfo.arbitration.arbTypeNum == 3 &&<p>
                  <span style={{ color: '#333' }}>散户 {basicInfo?.arbitration?.user?.name} 质保期内申请免费上门</span>
                    <span style={{ paddingLeft: '20px' }}>申请时间：{dayjs(basicInfo.arbitration?.arbitrationRelation?.createdAt).format("YYYY-MM-DD HH:mm:ss")}</span>
                  </p>
                  }
                  {basicInfo.arbitration.arbTypeNum == 3 &&<div style={{ padding: '10px', background: '#fbcecb' }}>
                    <OrderRow title="申请原因">
                      {basicInfo.arbitration?.arbitrationRelation?.remark || ''}
                    </OrderRow>
                    <OrderRow title="图片">
                      {basicInfo.arbitration?.arbitrationRelation?.resource_file?.map((item, index) => {
                        return (
                          <img src={item} key={index} style={{ width: 48, height: 48 }}
                            onClick={() => previewImage(basicInfo.arbitration?.arbitrationRelation?.resource_file?.map(v => ({ url: v })), index)}
                          />
                        )
                      })}
                    </OrderRow>
                  </div>
                  }

                  {basicInfo.arbitration.arbTypeNum == 4 &&<p>
                  <span style={{ color: '#333' }}>师傅 {basicInfo?.arbitration?.user?.realname} 申请新增费用金额</span>
                    <span style={{ paddingLeft: '20px' }}>申请时间：{dayjs(basicInfo.arbitration?.arbitrationRelation?.createdAt).format("YYYY-MM-DD HH:mm:ss")}</span>
                  </p>
                  }
                  {basicInfo.arbitration.arbTypeNum == 4 &&<div style={{ padding: '10px', background: '#fbcecb' }}>
                    <OrderRow title="申请费用">
                      {basicInfo.arbitration?.arbitrationRelation?.detail?.map((item, index) => `${item.fee_name}${(item.fee_value*1)?.toFixed(2)}元 ${index < basicInfo.arbitration?.arbitrationRelation?.detail.length - 1 ? "/" : ""}`).join(' ') || ''}
                    </OrderRow>
                    <OrderRow title="申请原因">
                      {basicInfo.arbitration?.arbitrationRelation?.remark || ''}
                    </OrderRow>
                    <OrderRow title="图片">
                      {basicInfo.arbitration?.arbitrationRelation?.resource_file?.map((item, index) => {
                        return (
                          <img src={item} key={index} style={{ width: 48, height: 48 }}
                            onClick={() => previewImage(basicInfo.arbitration?.arbitrationRelation?.resource_file?.map(v => ({ url: v })), index)}
                          />
                        )
                      })}
                    </OrderRow>
                  </div>
                  }
                  
                </Timeline.Item>
                {(basicInfo.arbitration?.arbitrationRelation?.status > 0 || basicInfo.arbitration?.arbitrationRelation?.status_flag > 0) &&<Timeline.Item>
                {basicInfo.arbitration.arbTypeNum == 1 &&<p>
                    <span style={{ color: '#333' }}>师傅 {basicInfo.arbitration?.arbitrationRelation?.worker?.realname} <em style={{ fontStyle: 'normal', color: '#FF731B' }}>{basicInfo.arbitration?.arbitrationRelation?.status_flag === 1 ? '同意' : '拒绝'}</em>下调费用金额申请</span>
                    <span style={{ paddingLeft: '20px' }}>时间：{dayjs(basicInfo.arbitration?.arbitrationRelation?.checkTime).format("YYYY-MM-DD HH:mm:ss")}</span>
                  </p>
                }

                {basicInfo.arbitration.arbTypeNum == 2 &&<p>
                    <span style={{ color: '#333' }}>师傅 {basicInfo.arbitration?.arbitrationRelation?.checker?.name} <em style={{ fontStyle: 'normal', color: '#FF731B' }}>{basicInfo.arbitration?.arbitrationRelation?.status === 1 ? '同意' : '拒绝'}</em>退款申请</span>
                    <span style={{ paddingLeft: '20px' }}>时间：{dayjs(basicInfo.arbitration?.arbitrationRelation?.arbitrationRelation?.checkedAt).format("YYYY-MM-DD HH:mm:ss")}</span>
                  </p>
                }
                {basicInfo.arbitration.arbTypeNum == 3 &&<p>
                    <span style={{ color: '#333' }}>师傅 {basicInfo.arbitration?.arbitrationRelation?.worker?.realname} <em style={{ fontStyle: 'normal', color: '#FF731B' }}>{basicInfo.arbitration?.arbitrationRelation?.status === 1 ? '同意' : '拒绝'}</em>质保期内免费上门申请</span>
                    <span style={{ paddingLeft: '20px' }}>时间：{dayjs(basicInfo.arbitration?.arbitrationRelation?.updatedAt).format("YYYY-MM-DD HH:mm:ss")}</span>
                  </p>
                }
                {basicInfo.arbitration.arbTypeNum == 4 &&<p>
                    <span style={{ color: '#333' }}>散户 {basicInfo.arbitration?.arbitrationRelation?.user?.name} <em style={{ fontStyle: 'normal', color: '#FF731B' }}>{basicInfo.arbitration?.arbitrationRelation?.status_flag === 1 ? '同意' : '拒绝'}</em>新增费用申请</span>
                    <span style={{ paddingLeft: '20px' }}>时间：{dayjs(basicInfo.arbitration?.arbitrationRelation?.checkTime).format("YYYY-MM-DD HH:mm:ss")}</span>
                  </p>
                }
                 {(basicInfo.arbitration?.arbitrationRelation?.status_flag == 2 || basicInfo.arbitration?.arbitrationRelation?.status == 2) &&<div style={{ padding: '10px', background: '#fbcecb' }}>
                    <OrderRow title="拒绝原因">
                      {basicInfo.arbitration?.arbitrationRelation?.reason || (basicInfo.arbitration?.arbitrationRelation?.refuse_reason || '')}
                    </OrderRow>
                  </div>
                }
                </Timeline.Item>
                }
                <Timeline.Item>
                  <p>
                    <span style={{ color: '#333' }}>{basicInfo.arbitration?.type === 1 ? ('师傅 '+basicInfo?.worker?.realname) : ('散户 '+basicInfo.arbitration?.user?.name)} 发起仲裁</span>
                    <span style={{ paddingLeft: '20px' }}>申请时间：{dayjs(basicInfo.arbitration?.createdAt).format("YYYY-MM-DD HH:mm:ss")}</span>
                  </p>
                  <div style={{ padding: '10px', background: '#fbcecb' }}>
                    <OrderRow title="仲裁类型">
                    {basicInfo.arbitration?.arbType || ''}
                    </OrderRow>
                    <OrderRow title="情况说明">
                    {basicInfo.arbitration?.intro || ''}
                    </OrderRow>
                    <OrderRow title="图片">
                    {basicInfo.arbitration?.resourceFile?.map((item, index) => {
                        return (
                          <img src={item} key={index} style={{ width: 48, height: 48 }}
                            onClick={() => previewImage(basicInfo.arbitration?.resourceFile?.map(v => ({ url: v })), index)}
                          />
                        )
                      })}
                    </OrderRow>
                  </div>
                </Timeline.Item>
                {basicInfo.arbitration.isAppeal == true &&<Timeline.Item>
                  <p>
                  <span style={{ color: '#333' }}> {basicInfo.arbitration?.type === 1 ? ('散户 '+basicInfo.arbitration?.user?.name) : ('师傅 '+basicInfo.arbitration?.appealUser?.roles?.worker?.realname)} 发起申诉</span>
                    <span style={{ paddingLeft: '20px' }}>申请时间：{dayjs(basicInfo.arbitration?.arbitrationRelation?.createdAt).format("YYYY-MM-DD HH:mm:ss")}</span>
                  </p>
                  <div style={{ padding: '10px', background: '#fbcecb' }}>
                  <OrderRow title="申诉情况说明">
                    {basicInfo.arbitration?.appealIntro || ''}
                  </OrderRow>
                  <OrderRow title="申诉上传图片">
                    {basicInfo.arbitration?.appealResourceFile?.map((item, index) => {
                      return (
                        <img src={item} key={index} style={{ width: 48, height: 48 }}
                          onClick={() => previewImage(basicInfo.arbitration?.appealResourceFile?.map(v => ({ url: v })), index)}
                        />
                      )
                    })}
                  </OrderRow>
                  </div>
                </Timeline.Item>}
                {basicInfo.arbitration?.arbitrationAginList?.map((item, index) => {
                      return (
                <Timeline.Item>
                  <p>
                    <span style={{ color: '#333' }}>{item?.type === 1 ? ('师傅 '+item?.user?.roles?.worker?.realname) : ('散户 '+item?.user?.name)} 补充材料</span>
                    <span style={{ paddingLeft: '20px' }}>提交时间：{dayjs(item?.createdAt).format("YYYY-MM-DD HH:mm:ss")}</span>
                  </p>
                  <div style={{ padding: '10px', background: '#fbcecb' }}>
                    <OrderRow title="情况说明">
                    {item?.intro || ''}
                    </OrderRow>
                    <OrderRow title="图片">
                    {item?.resourceFile?.map((itemF, index) => {
                        return (
                          <img src={itemF} key={index} style={{ width: 48, height: 48 }}
                            onClick={() => previewImage(item?.resourceFile?.map(v => ({ url: v })), index)}
                          />
                        )
                      })}
                    </OrderRow>
                  </div>
                </Timeline.Item>
                )
              })}
              </Timeline>
            </div>
          </div>
          <div className={styles.blockfoot}>
            <Button type="primary" size="small" style={{ marginLeft: '10px' }}
              onClick={() => {
                managerArbitrationCheck({
                  arbId: basicInfo.arbitration?._id,
                  status: 1
                })
                // openModal(`同意${basicInfo.arbitration?.type === 1 ? '师傅' : '散户'}下调费用金额`, 9)
              }}
            >同意
                {basicInfo.arbitration?.arbTypeNum == 4 && <span>师傅新增费用</span>}
                {basicInfo.arbitration?.arbTypeNum == 1 && <span>散户下调费用金额</span>}
                {basicInfo.arbitration?.arbTypeNum == 2 && <span>散户申请退款</span>}
                {basicInfo.arbitration?.arbTypeNum == 3 && <span>质保期内师傅拒绝免费上门</span>}
            </Button>
            <Button type="primary" size="small" style={{ marginLeft: '10px' }}
              onClick={() => { openModal(`拒绝${basicInfo.arbitration?.type === 1 ? '师傅' : '散户'}下调费用金额`, 10) }}
            >拒绝</Button>
          </div>
        </div>}
      </>}

      {basicInfo.guaqi && <div className={styles.block}>
        <div className={styles.blocktitle}>
          <div className={styles.titletext}>师傅挂起工单</div>
          <div className={styles.titletime}>挂起时间：{dayjs(basicInfo.guaqi.guaqi_time).format("YYYY-MM-DD HH:mm:ss")}</div>
        </div>
        <div className={styles.blockbody}>
          <OrderRow title="挂起原因">{basicInfo.guaqi.guaqi_reason}</OrderRow>
          <OrderRow title="预约时间">{basicInfo.guaqi.service_time ? dayjs(basicInfo.guaqi.service_time).format("YYYY-MM-DD HH:mm:ss") : ''}</OrderRow>
        </div>
      </div>}

      {(isManagerMode || (!isManagerMode && order?.get('ticket_type') == 2)) && <>

        {basicInfo.applyFee && <div className={styles.block}>
          <div className={styles.blocktitle}>
            <div className={styles.titletext}>师傅申请费用</div>
            <div className={styles.titletime}>申请时间：{dayjs(basicInfo.applyFee.createdAt).format("YYYY-MM-DD HH:mm:ss")}</div>
          </div>
          <div className={styles.blockbody}>
            {basicInfo.applyFee.detail?.map((item, index) => {
              return (
                <OrderRow title={item.fee_name} key={index}>
                  <span className={styles.textcolor1} >
                    {item.fee_value || 0}元
                  </span>
                </OrderRow>
              )
            })}
            <OrderRow title="申请原因">{basicInfo.applyFee.remark}</OrderRow>
          </div>
          <div className={styles.blockfoot}>
            <Button type="primary" size="small" style={{ marginLeft: '10px' }}
              onClick={() => { openModal('同意师傅申请费用', 1) }}
            >同意</Button>
            <Button type="primary" size="small" style={{ marginLeft: '10px' }}
              onClick={() => { openModal('拒绝师傅申请费用', 2) }}
            >拒绝</Button>
          </div>
        </div>}
      </>}
      {basicInfo.appealList && <div className={styles.block}>
        <div className={styles.blocktitle}>
          <div className={styles.titletext}>申请调价</div>
          <div className={styles.titletime}>申请时间：{dayjs(basicInfo.appealList?.appeal_time).format("YYYY-MM-DD HH:mm:ss")}</div>
        </div>
        <div className={styles.blockbody}>
          <OrderRow title="金额(元)">
            <span className={styles.textcolor1} >
              {basicInfo.appealList?.appeal_amount || 0}元
            </span>
          </OrderRow>
          <OrderRow title="调价方式">
            {basicInfo.appealList?.appeal_type == 1 && <span>下调</span>}
            {basicInfo.appealList?.appeal_type == 2 && <span>上调</span>}
          </OrderRow>
          <OrderRow title="调价原因">{basicInfo.appealList?.appeal_reason}</OrderRow>
          <OrderRow title="图片">
            {basicInfo.appealList?.images?.map((item, index) => {
              return (
                <img src={item.url} key={index} style={{ width: 48, height: 48 }}
                  onClick={() => previewImage(basicInfo.appealList?.images, index)}
                />
              )
            })}
          </OrderRow>
        </div>
        <div className={styles.blockfoot}>
          <Button type="primary" size="small" style={{ marginLeft: '10px' }}
            onClick={() => { openModal('同意申请调价', 7) }}
          >同意</Button>
          <Button type="primary" size="small" style={{ marginLeft: '10px' }}
            onClick={() => { openModal('拒绝申请调价', 8) }}
          >拒绝</Button>
        </div>
      </div>}

      <Modal
        title={modalTitle}
        destroyOnClose
        width={(modalType % 2 == 1 && ![9, 10].includes(modalType)) ? 350 : 520}
        visible={isOpen}
        onOk={() => { handleSubmit() }}
        onCancel={() => { closeModal() }}

        mask={false}
        wrapClassName="order-detail-modal-wrap"
        maskStyle={{ position: 'absolute' }}
        getContainer={() => document.getElementById('order-detail-wrap') || window}
      >
        <div>
          <Form
            {...formItemLayout}
          >
            {modalType == 1 && <div className={styles.orderNoticeTips}>
              <div className={styles.tipsiconbox}>
                <div className={styles.tipsicon}>
                  <Icon type="exclamation-circle" theme="filled" />
                </div>
                <div className={styles.tipstext}>
                  点击【确定】后将同意师傅的改价。
                </div>
              </div>
            </div>}
            {modalType == 3 && <div className={styles.orderNoticeTips}>
              <div className={styles.tipsiconbox}>
                <div className={styles.tipsicon}>
                  <Icon type="exclamation-circle" theme="filled" />
                </div>
                <div className={styles.tipstext}>
                  点击【确定】后将同意师傅的申诉
                </div>
              </div>
              <div className={styles.tipsdesc}>
                {order?.get('is_retail') ? '散户' : '商家'}的两项低于2星的评价将系统调整至正常评价，不纳入师傅派单率统计。
              </div>
            </div>}
            {modalType == 5 && <div className={styles.orderNoticeTips}>
              <div className={styles.tipsiconbox}>
                <div className={styles.tipsicon}>
                  <Icon type="exclamation-circle" theme="filled" />
                </div>
                <div className={styles.tipstext}>
                  点击【确定】后将同意{order?.get('is_retail') ? '散户' : '商家'}的索赔
                </div>
              </div>
              <div className={styles.tipsdesc}>
                {order?.get('is_retail') ? '散户' : '商家'}的索赔金额需从师傅的保证金中扣除，并退还至{order?.get('is_retail') ? '散户' : '企业'}的账户余额中。
              </div>
            </div>}
            {modalType == 7 && <div className={styles.orderNoticeTips}>
              <div className={styles.tipsiconbox}>
                <div className={styles.tipsicon}>
                  <Icon type="exclamation-circle" theme="filled" />
                </div>
                <div className={styles.tipstext}>
                  点击【确定】后将同意申请调价
                </div>
              </div>
            </div>}
            {[2, 4, 6, 8, 9, 10].includes(modalType) && <Form.Item
              label="原因"
            >
              {getFieldDecorator('reason', {
                rules: [
                  { required: true, message: `请输入原因`, }
                ],
              })(
                <Input.TextArea rows={4} placeholder={`请输入原因`} />
              )}
            </Form.Item>}
          </Form>
        </div>
      </Modal>
    </div>
  )
}

export default Form.create()(OrderNotice)